import { useEffect, useRef } from "react"

/**
 * コンポーネントのマウント時に一度だけ、effect関数を呼ぶためのhooksです。
 * 依存配列を空にするだけでなく、refでマウントされたか判定しているのは以下の理由からです。
 * 1.Fast Refresh時に再度effect関数が呼ばれるのを防ぐため
 * 2.React18でのStrict Modeへの対応(Offscreen APIなどの将来追加される予定のAPIへの対応)
 * @see https://blog.koba04.com/post/2021/06/16/effects-in-react-v18
 */
const useMountEffect = (effect: React.EffectCallback) => {
  const isMounted = useRef(false)

  useEffect(() => {
    if (!isMounted.current) {
      isMounted.current = true
      return effect()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}

export default useMountEffect
